import React, { useEffect } from "react";
import $ from "jquery";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import BookCall from "../components/BookCall";
import ScrollToTopButton from "../components/ScrollToTopButton";

export default function AboutPage() {
  useEffect(() => {
    const animate = () => {
      $(".reveal-on-scroll").each(function () {
        const elementTop = $(this).offset().top;
        const scrollTop = $(window).scrollTop();
        const windowHeight = $(window).height();

        if (scrollTop + windowHeight > elementTop + 50) {
          $(this).css({
            opacity: 1,
            transform: "translateY(0)",
            transition: "all 1s ease",
          });
        }
      });
    };

    animate(); // run on mount
    $(window).on("scroll", animate);
    return () => $(window).off("scroll", animate);
  }, []);

  const hiddenStyle = {
    opacity: 0,
    transform: "translateY(40px)",
  };

  return (
    <>
      <Navbar />

      {/* Banner Section */}
      <div
        className="text-white text-center d-flex align-items-center justify-content-center"
        style={{
          height: "60vh",
          backgroundImage:
            "linear-gradient(rgba(0,0,0,0.6), rgba(0,0,0,0.6)), url('/images/wwd.png')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          animation: "fadeIn 2s ease-in-out",
        }}
      >
        <div>
          <h1 className="display-4 fw-bold mb-3">About Vizionexl</h1>
          <p className="lead">BUILT WITH VISION. DELIVERED WITH EXCELLENCE.</p>
        </div>
      </div>

      {/* Section 1: Innovation */}
      <div className="row align-items-center mt-5 mb-5 ml-4">
        <div className="col-md-6 reveal-on-scroll text-center" style={hiddenStyle}>
          <img
            src="/images/about1.png"
            alt="Digital Innovation"
            className="img-fluid w-75 rounded shadow-sm"
          />
        </div>
        <div className="col-md-6 reveal-on-scroll" style={hiddenStyle}>
          <h4 className="fw-bold mb-3">Driving Innovation with Technology</h4>
          <p>
            At <strong>Vizionexl</strong>, we’re not just a technology company — we’re innovation
            enablers. Our passion lies in harnessing the power of emerging technologies to solve
            real-world problems and unlock business potential.
          </p>
          <p>
            Whether it’s developing scalable platforms, optimizing enterprise operations, or crafting
            engaging user experiences, our solutions are tailored to fuel transformation and
            accelerate growth. With each project, we commit to delivering not just functionality, but
            forward-thinking, strategic value.
          </p>
        </div>
      </div>

      {/* Section 2: Team */}
      <div className="row align-items-center flex-md-row-reverse mb-5 ml-4">
        <div className="col-md-6 reveal-on-scroll text-center" style={hiddenStyle}>
          <img
            src="/images/about2.png"
            alt="Our Team"
            className="img-fluid w-75 rounded shadow-sm"
          />
        </div>
        <div className="col-md-6 reveal-on-scroll" style={hiddenStyle}>
          <h4 className="fw-bold mb-3">A Team Built for the Future</h4>
          <p>
            At the heart of Vizionexl is a team that thrives on challenge and collaboration.
            Comprised of expert developers, ethical hackers, UI/UX specialists, analysts, and
            strategic consultants, our people bring a rich mix of creativity, technical mastery, and
            domain insight.
          </p>
          <p>
            We believe that the future belongs to the agile. That’s why our team continuously evolves
            — learning, adapting, and innovating to stay ahead in a fast-changing digital landscape.
            Every solution we create is backed by a future-ready mindset and a commitment to quality.
          </p>
        </div>
      </div>

      {/* Section 3: Empowering Businesses */}
      <div className="row text-center">
        <div className="col-lg-8 offset-lg-2 reveal-on-scroll" style={hiddenStyle}>
          <h4 className="fw-bold mb-3">Empowering All Businesses</h4>
          <p>
            No matter the size or stage of your business, Vizionexl is here to help you leverage the
            full potential of digital transformation. From agile startups bringing bold ideas to life
            to large enterprises upgrading legacy systems — we craft solutions that scale with you.
          </p>
          <p className="fw-semibold text-primary">
            We combine deep tech expertise with strategic insight to help our clients lead with
            confidence in the digital era.
          </p>
          <div className="text-start mt-4">
            <h4 className="fw-bold">Our Mission</h4>
            <p>
              To build intelligent and robust digital ecosystems that empower organizations and
              individuals globally, driving long-term value, innovation, and success.
            </p>
            <h4 className="fw-bold mt-4">Our Vision</h4>
            <p>
              To be a globally trusted technology partner—known for delivering cutting-edge
              innovation, seamless experiences, and measurable results in every solution we provide.
            </p>
          </div>
        </div>
      </div>

      <BookCall />
      <Footer />
      <ScrollToTopButton />
    </>
  );
}
